export default class ResponsiveVideo {
	constructor(video) {
		this.video = video;
		this.width = this.video.getBoundingClientRect().width * window.devicePixelRatio; // Get width taking pixel density into account

		this.pickSource();
	}

	static init(){
		document.querySelectorAll('[data-video]').forEach((video) => {
			new ResponsiveVideo(video);
		});
	}

	pickSource() {
		const sources = this.video.querySelectorAll('source');
		let prevDiff = 999999;
		let matchedSource = null;

		sources.forEach((source) => {
			// Get source resolution (by provided by data attribute)
			let sourceWidth = source.dataset.sourcewidth;
			// Compare source resolution to video element width
			let currentDiff = sourceWidth - this.width;

			if (currentDiff <= 0) {
				currentDiff = currentDiff * -1;
			}

			if (currentDiff <= prevDiff) {
				matchedSource = source;
			}

			prevDiff = currentDiff;

			source.remove();
		});

		setTimeout(() => {
			this.video.src = matchedSource.src;
		}, 0);
	}
}
